import { STORAGE_KEYS } from '@/constants/storage'
import convertStringToBoolean from '@/utils/convertStringToBoolean'
import localStorage from '@/utils/localStorage'
import * as R from 'ramda'

const isExpired = (expiryTime, action) => {
  if (expiryTime === action) return true
}

/**
 * This function scans obj, and returns paths to child objects with **expiresOn** set as **action**
 * @param obj
 * @param action
 * @param key
 * @returns {boolean|*[]|*}
 */
const getExpiredPaths = (obj, action, key) => {
  let paths = []
  if (typeof obj === 'object') {
    const nestedValues = Object.entries(obj).filter(([, value]) => typeof value === 'object')
    if (isExpired(obj.expiresOn, action)) {
      return key
    } else if (nestedValues.length > 0) {
      nestedValues.map(([key, value]) => {
        const expiredPaths = getExpiredPaths(value, action, key)
        if (expiredPaths) {
          if (Array.isArray(expiredPaths)) {
            paths.push(...expiredPaths.map(path => [key, ...(Array.isArray(path) ? path : [path])]))
          } else {
            paths.push(expiredPaths)
          }
        }
      })
    } else {
      return false
    }
  }
  return paths
}

export const invalidateStorage = (key, action) => {
  let obj = localStorage.getItem(key, 'json')
  if (obj) {
    const paths = getExpiredPaths(obj, action)
    paths.forEach(path => {
      obj = R.dissocPath(path, obj)
    })
  }
  localStorage.setItem(key, obj)
}

export const clearStorageKeys = keys => keys.forEach(localStorage.removeItem)

export const storageFlags = {
  get(key) {
    const flags = localStorage.getItem(STORAGE_KEYS.flags, 'json') || {}
    return convertStringToBoolean(flags[key])
  },
  set(key) {
    const flags = localStorage.getItem(STORAGE_KEYS.flags, 'json') || {}
    flags[key] = true
    localStorage.setItem(STORAGE_KEYS.flags, flags)
  },
  remove(key) {
    const flags = localStorage.getItem(STORAGE_KEYS.flags, 'json') || {}
    delete flags[key]
    localStorage.setItem(STORAGE_KEYS.flags, flags)
  }
}
